import { useContext } from 'react'

import { type ContextType, context } from './context'

let hasWarned = false

const mockContext: ContextType = {
	push: () => {
		console.log('Attempted navigate without routing context')
	},
	replace: () => {
		console.log('Attempted replace url without routing context')
	},
	back: () => {
		console.log('Attempted back without routing context')
	},
	getPath: ({ name, params }, base = '') => {
		const paramString = params
			? '/' +
				Object.entries(params)
					.map(([key, value]) => `${key}/${value}`)
					.join('/')
			: ''

		return `${base}/${name}${paramString}`
	},
	page: { name: 'MockPage' },
	url: '/mock/url',
	match: () => ({ name: 'MockPage' }),
	subscribe: () => () => {},
}

export const useRoutingContext = () => {
	const routingContext = useContext(context)

	if (routingContext) return routingContext

	if (!hasWarned) {
		console.warn('@subaio/components Router: No provider used, mocking links')
		hasWarned = true
	}

	return mockContext
}
